<template>
  <main id="orders-single" class="site-main">
    <div class="single-detail">
      <div class="grid-container">
        <div class="single-detail__header">
          <div class="single-detail__header__detail">
            <div class="grid-x align-bottom">
              <div class="cell shrink">
                <h1 style="font-size: 30px; margin: 0 15px 0 0;">{{ order.name }}</h1>
              </div>

              <div class="cell shrink">
                <div style="margin-right: 30px; position: relative; top: 1px;">{{ date }}</div>
              </div>

              <div class="cell shrink">
                <div class="grid-x align-middle" style="position: relative; top: -4px;">
                  <div class="cell shrink">
                    <div :class="['label', this.financialLabel]" style="margin-right: 10px;">
                      {{ financialStatus }}
                    </div>
                  </div>

                  <div class="cell shrink">
                    <div :class="['label', this.fulfillmentLabel]" style="margin-right: 10px;">
                      {{ fulfillmentStatus }}
                    </div>
                  </div>
                </div>
              </div>

              <div class="cell auto text-right">
                <div style="font-size: 24px; font-weight: 700;">{{ price }}</div>
              </div>
            </div>
          </div>

          <div class="single-detail__header__actions">
            <a :href="order.url" target="_blank"><i class="fas fa-eye"></i> View in Shopify</a>
          </div>
        </div>

        <div class="grid-x grid-padding-x">
          <div class="cell large-auto">
            <div class="panel no-padding">
              <div :class="['loading-area', loading ? 'loading' : '']">
                <div :class="['loading-area__content', loading ? 'loading' : '']">
                  <div class="line-items">
                    <tableList classes="no-hover" :header="tableHeader" :data="tableData"
                               :loading="loading" @sort="orderBy" @callback="callback"></tableList>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="cell large-shrink">
            <div class="sidebar">
              <div class="panel">
                <div class="form-field">
                  <label>Customer</label><br>
                  <div>{{ order.customer_name }}</div>
                </div>

                <hr>

                <div class="form-field">
                  <label>Notes</label><br>
                  <div>{{ order.note }}</div>
                </div>

                <hr>

                <div class="form-field">
                  <label>Shipping</label><br>
                  <div>{{ order.address1 }} {{ order.address2 }}<br>
                    {{ order.city }}, {{ order.province }} {{ order.zip }}
                  </div>
                </div>

                <hr>

                <div class="form-field">
                  <label>Tags</label><br>
                  <div class="tags" v-html="order.tags"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="fade">
      <div class="overlay" v-if="editingCommission">
        <div class="overlay__inner">
          <div class="panel">
            <div class="panel__header">
              <h3 class="panel__title">Set Commission</h3>

              <span class="overlay__close" @click="closeCommission">
                <i class="fal fa-times"></i></span>
            </div>

            <div class="panel__content">
              <form>
                <input id="line-item-id" name="id" type="hidden">

                <div class="form-field">
                  <div class="grid-x grid-padding-x">
                    <div class="cell small-4">
                      <label for="commission-override">Set Commission</label>
                    </div>

                    <div class="cell auto">
                      <input id="commission-override" class="short-input" name="commission"
                             type="text" :value="editingCommissionValue">
                    </div>
                  </div>
                </div>
              </form>
            </div>

            <div class="panel__footer text-right">
              <button class="button--alt" @click="closeCommission">Cancel</button>

              <button @click="saveCommission()">Save</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="overlay" v-if="editingVendor">
        <div class="overlay__inner">
          <div class="panel" style="overflow: initial;">
            <div class="panel__header">
              <h3 class="panel__title">Set Vendor</h3>

              <span class="overlay__close" @click="closeVendor">
                <i class="fal fa-times"></i></span>
            </div>

            <div>
              <input name="order_id" type="hidden" value="">
              <input id="" name="id" type="hidden">

              <div class="form-field">
                <div class="grid-x grid-padding-x">
                  <div class="cell small-4">
                    <label for="vendor-override">Set Vendor</label>
                  </div>

                  <div class="cell auto">
                    <div class="searchable-field">
                      <input id="vendor-override" name="vendor-override" type="text"
                             placeholder="type 3 characters to search..."
                             v-on:input='searchVendors($event.target.value)'>

                      <div class="searchable-field__data" v-if="searchedVendors.length > 0">
                        <div :id="row.id" class="searchable-field__option"
                             v-for="(row, key) in searchedVendors" :key="key"
                             @click="chooseVendor(row.id, row.name)">
                          {{ row.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel__footer text-right">
              <button class="button--alt" @click="closeVendor">Cancel</button>

              <button @click="saveVendor">Save</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </main>
</template>

<script>
import client from '@/mixins/client'
import paginationUtils from '@/mixins/paginationUtils'
import moment from 'moment'

export default {
  name: 'ordersSingle',
  mixins: [client, paginationUtils],
  data: function () {
    return {
      editingLineItem: null,
      editingCommission: false,
      editingCommissionValue: '',
      editingVendor: false,
      searchingVendors: false,
      searchedVendors: [],
      overrideVendor: null,
      order: {
        name: '#0000',
        url: '#'
      },
      date: 'Mon 1, 1970 at 0:00am',
      financialLabel: '',
      financialStatus: 'Payment',
      fulfillmentLabel: '',
      fulfillmentStatus: 'Fulfillment',
      price: 0,
      action: '/orders/' + this.$route.params.id + '/',
      sort: 'product__title',
      tableHeader: {
        data: [
          {
            label: 'Product',
            class: 'full'
          },
          {
            label: 'Fulfillment',
            class: 'medium'
          },
          {
            label: 'Price'
          },
          {
            label: 'Commission'
          },
          {
            label: 'Vendor',
            class: 'large'
          }
        ]
      },
      tableData: []
    }
  },
  methods: {
    editCommission (lineItem, value) {
      this.editingCommission = true
      this.editingLineItem = lineItem
      this.editingCommissionValue = value
    },
    closeCommission () {
      this.editingCommission = false
    },
    chooseVendor (id, name) {
      let vendorInput = document.getElementById('vendor-override')
      vendorInput.value = name
      this.searchedVendors = false
      this.overrideVendor = id
    },
    saveVendor () {
      this.request('put', '/orders/lineitems/' + this.editingLineItem.id + '/', {
        override_vendor: this.overrideVendor
      }).then(response => {
        this.editingVendor = false
        this.getData()
      })
    },
    searchVendors (value) {
      if (value.length > 0 && !this.searchingVendors) {
        this.searchingVendors = true

        this.request('get', '/vendors/commission-totals/', {
          search: value,
          ordering: 'name'
        }).then(response => {
          let items = response.results
          this.searchedVendors = []

          for (let i = 0; i < items.length; i++) {
            this.searchedVendors.push({
              id: items[i].id,
              name: items[i].name
            })
          }

          this.searchingVendors = false
        })
      }
    },
    saveCommission () {
      this.loading = true

      let commission = document.getElementById('commission-override').value

      commission = commission.replace('$', '')
      commission = commission.replace('%', '')

      if (commission === '') {
        commission = null
      }

      this.editingCommission = false

      if (this.editingLineItem.override_commission_line_item.length > 0) {
        this.request('put', '/vendors/override-commission/' + this.editingLineItem.override_commission_line_item[0].id + '/update/', {
          line_item: this.editingLineItem.id,
          commission: commission
        }).then(response => {
          this.getData()
        })
      } else {
        this.request('post', '/vendors/override-commission/create/', {
          line_item: this.editingLineItem.id,
          commission: commission
        }).then(response => {
          this.getData()
        })
      }
    },
    editVendor (lineItem, value) {
      this.overrideVendor = null
      this.editingVendor = true
      this.editingLineItem = lineItem
    },
    closeVendor () {
      this.editingVendor = false
    },
    buildTable () {
      this.tableData = []
      this.order = this.data

      this.date = moment(this.data.processed_at).format('MMM D, YYYY [at] h:mma')
      this.price = this.formatMoney(this.data.total_price)

      this.order.url = 'https://' + this.$store.state.shop.myshopify_domain + '/admin/orders/' + this.order.order_id

      if (this.isEmpty(this.order.customer_name)) {
        this.order.customer_name = 'N/A'
      }

      if (this.isEmpty(this.order.note)) {
        this.order.note = 'N/A'
      }

      if (!this.isEmpty(this.order.tags)) {
        let tags = this.order.tags.split(',')
        this.order.tags = ''

        for (let i = 0; i < tags.length; i++) {
          this.order.tags += '<div class="label">' + tags[i].trim() + '</div>'
        }
      }

      this.financialStatus = this.data.financial_status
      this.fulfillmentStatus = this.data.fulfillment_status

      if (this.data.financial_status === 'pending' ||
        this.data.financial_status === 'partially_paid' ||
        this.data.financial_status === 'partially_refunded' ||
        this.data.financial_status === 'authorized') {
        this.financialLabel = 'warning'
      } else if (this.data.financial_status === 'voided' ||
        this.data.financial_status === 'refunded') {
        this.financialLabel = 'alert'
      } else {
        this.financialLabel = 'success'
      }

      if (this.data.fulfillment_status === 'partial') {
        this.fulfillmentLabel = 'warning'
        this.fulfillmentStatus = 'Partially Fulfilled'
      } else if (this.data.fulfillment_status === 'restocked' ||
        this.data.fulfillment_status === null) {
        this.fulfillmentLabel = 'alert'
      } else {
        this.fulfillmentLabel = 'success'
      }

      if (this.data.fulfillment_status === null) {
        this.fulfillmentStatus = 'Unfulfilled'
      }

      this.financialStatus = this.formatText(this.financialStatus)
      this.fulfillmentStatus = this.formatText(this.fulfillmentStatus)

      let lineItems = this.data.line_items

      for (let i = 0; i < lineItems.length; i++) {
        let primary = '<div class="grid-x align-middle"><div class="cell shrink">' +
          '<div class="table-list__image">'

        if (!this.isEmpty(lineItems[i].image) && lineItems[i].image !== undefined) {
          primary += '<div class="table-list__image__inner">'
          primary += '<img src="' + lineItems[i].image + '">'
          primary += '</div>'
        } else {
          primary += '<div class="table-list__image__missing"><i class="fas fa-image"></i></div>'
        }

        if (lineItems[i].variant !== null) {
          if (lineItems[i].variant.product !== null) {
            primary += '</div></div><div class="cell auto"><span class="text-overflow">' + lineItems[i].variant.product.title + '</span>'
          } else {
            primary += '</div></div><div class="cell auto">'
          }

          if (lineItems[i].variant !== null && lineItems[i].variant.title !== null && lineItems[i].variant.title.length > 0 && lineItems[i].variant.title !== 'Default Title') {
            primary += '<br><span class="text-overflow"><small><i>' + lineItems[i].variant.title + '</i></small></span>'
          }
        } else {
          primary += '</div></div><div class="cell auto">'

          if (lineItems[i].title !== null && lineItems[i].title.length > 0 && this.$store.state.shop.myshopify_domain !== 'tnaa1k-9c.myshopify.com') {
            primary += '<span class="text-overflow">' + lineItems[i].title + '</span>'
          } else {
            primary += '<span class="text-overflow">' + lineItems[i].name + '</span>'
          }
        }

        if (lineItems[i].sku !== null && lineItems[i].sku.length > 0) {
          primary += '<br><span class="text-overflow"><small><i>' + lineItems[i].sku + '</i></small></span>'
        }

        primary += '</div></div>'

        let lineItemFulfillmentStatus = 'success'

        if (lineItems[i].fulfillment_status === 'partial') {
          lineItemFulfillmentStatus = 'warning'
          lineItems[i].fulfillment_status = 'Partially Fulfilled'
        } else if (lineItems[i].fulfillment_status === 'restocked' ||
          lineItems[i].fulfillment_status === null) {
          lineItemFulfillmentStatus = 'alert'
        }

        if (lineItems[i].fulfillment_status === null || lineItems[i].fulfillment_status.length === 0) {
          lineItems[i].fulfillment_status = 'Unfulfilled'
          lineItemFulfillmentStatus = 'alert'
        }

        let price = '<div class="grid-x"><div class="cell shrink">' + this.formatMoney(lineItems[i].price)

        if (lineItems[i].allocated_discount > 0) {
          price += '<div class="text-right">-' + this.formatMoney(lineItems[i].allocated_discount) + '</div>'
        }

        price += '</div><div class="cell auto text-right" style="white-space: nowrap;">x ' + lineItems[i].quantity + '</div></div>'

        let commission = this.formatMoney(lineItems[i].commission_amount)

        let commissionCol = {
          value: commission,
          span: 'focus-text',
          edit: true,
          callback: 'editCommission',
          callbackArgs: [lineItems[i], null]
        }

        if (lineItems[i].commission_type === 'override') {
          commission = '*' + commission

          commissionCol['value'] = commission
          commissionCol['callbackArgs'] = [lineItems[i], lineItems[i].commission_amount.toFixed(2)]
        }

        if (lineItems[i].vendor_paid) {
          commissionCol['value'] = '<strike>' + commission + '</strike>'
          commissionCol['edit'] = false
          commissionCol['callback'] = null
        }

        let vendorName = ''

        if (lineItems[i].vendor) {
          vendorName = lineItems[i].vendor.name
        }

        if (lineItems[i].override_vendor !== null) {
          vendorName = '*' + lineItems[i].override_vendor.name
        }

        if (vendorName.length === 0) {
          vendorName = 'N/A'
        }

        this.tableData.push({
          post: lineItems[i].id,
          data: [
            {
              value: primary,
              class: 'full'
            },
            {
              value: this.formatText(lineItems[i].fulfillment_status),
              class: 'medium',
              span: 'label ' + lineItemFulfillmentStatus
            },
            {
              value: price,
              span: 'fill'
            },
            commissionCol,
            {
              value: vendorName,
              class: 'large',
              edit: true,
              callback: 'editVendor',
              callbackArgs: [lineItems[i], null]
            }
          ]
        })
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style lang="scss">
  @import '../../styles/variables';
  @import '../../styles/mixins';

  .line-items {
    padding: 15px 0;

    .table-list__body > .grid-x:last-child {
      border-bottom: 0;
    }
  }

  .tags {
    .label {
      margin: 0 5px 5px 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/single.vue